<template>
  <div>
    <b-container>
      <FormulateForm v-model="data" @submit="handleSubmit">
        <h2 class="mt-5 mb-4">One Time No Ride Report</h2>
        <FormSection name="Student Information">
          <FormulateInput type="group" name="student">
            <b-row>
              <b-col md="4">
                <FormulateInput
                  label="First name"
                  type="text"
                  name="first_name"
                  validation="^required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  label="Last name"
                  type="text"
                  name="last_name"
                  validation="^required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  label="Student ID"
                  type="text"
                  name="student_id"
                  validation="^required"
                />
              </b-col>
            </b-row>
          </FormulateInput>
        </FormSection>
        <FormSection class="mt-4" name="Requester Information">
          <FormulateInput type="group" name="requester">
            <b-row>
              <b-col md="4">
                <FormulateInput
                  label="First name"
                  type="text"
                  name="first_name"
                  validation="^required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  label="Last name"
                  type="text"
                  name="last_name"
                  validation="^required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  label="Relationship to student"
                  type="text"
                  name="relationship"
                  validation="^required"
                />
              </b-col>
            </b-row>
          </FormulateInput>
        </FormSection>
        <FormSection class="mt-4" name="No Ride Information">
          <FormulateInput type="group" name="no_ride">
            <b-row>
              <b-col md="4">
                <FormulateInput
                  label="Direction"
                  name="direction"
                  :options="{
                    I: 'Inbound',
                    O: 'Outbound',
                    B: 'Both'
                  }"
                  type="radio"
                  validation="^required"
                />
              </b-col>
              <b-col md="4">
                <FormulateInput
                  :label="data.no_ride[0].multiple ? 'Start date' : 'Date'"
                  type="date"
                  name="start_date"
                  :value="getTodayDate()"
                  @blur-context="updateMinEndDate()"
                  :min="getTodayDate()"
                  validation="^required"
                />
                <FormulateInput
                  label="Is this no ride for
                                multiple consecutive days?"
                  type="checkbox"
                  name="multiple"
                />
              </b-col>
              <b-col md="4" v-if="data.no_ride[0].multiple">
                <FormulateInput
                  label="Last date of no ride"
                  type="date"
                  name="end_date"
                  :value="getMinEndDate()"
                  :min="minEndDate"
                  :validation="[['^required'], ['afterToday']]"
                  :validation-rules="{
                    afterToday: ({ value }) => new Date(value) > new Date()
                  }"
                  :validation-messages="{
                    afterToday: 'End date should later than start date'
                  }"
                />
              </b-col>
            </b-row>
          </FormulateInput>
        </FormSection>
        <b-row>
          <b-col xs="12" class="text-center mt-3 mb-3">
            <FormulateErrors />
            <FormulateInput
              class="mt-3"
              type="submit"
              label="Submit"
              validation-behavior="live"
            />
          </b-col>
        </b-row>
      </FormulateForm>
      endpoint data: {{ data }}
    </b-container>
  </div>
</template>

<script>
import FormSection from '../components/FormSection.vue'
import { getUser, postNewOneTimeNoRideForm } from '../services/api'

export default {
  props: {
    student: {}
  },
  components: {
    FormSection
  },
  data() {
    return {
      user: {},
      data: {
        no_ride: [{}]
      }
    }
  },
  computed: {
    minEndDate: function() {
      let date = this.data.no_ride?.[0].start_date
      if (!this.data) {
        date = this.getTodayDate()
      }
      const startDate = new Date(date)
      let minEndDate = new Date(date)
      minEndDate.setDate(startDate.getDate() + 1)
      return minEndDate.toISOString().slice(0, 10)
    }
  },
  methods: {
    getTodayDate() {
      const today = new Date()
      return today.toISOString().slice(0, 10)
    },
    getMinEndDate() {
      return this.minEndDate
    },
    updateMinEndDate() {
      if (
        new Date(this.data.no_ride[0].end_date) < new Date(this.getMinEndDate())
      ) {
        this.data.no_ride[0].end_date = this.getMinEndDate()
      }
    },
    async updateUser() {
      let userResponse = await getUser()
      if (userResponse.status !== 200) {
        alert('Network Problem')
        throw new Error(userResponse.statusText)
      }
      this.user = userResponse.data
    },
    async handleSubmit() {
      try {
        const data = {
          student: this.student.internalId,
          requester_first_name: this.data.requester[0].first_name,
          requester_last_name: this.data.requester[0].last_name,
          requester_relationship: this.data.requester[0].relationship,
          start_date: this.data.no_ride[0].start_date,
          end_date: this.data.no_ride[0].end_date
            ? this.data.no_ride[0].end_date
            : null,
          direction: this.data.no_ride[0].direction,
          submit_user: this.user.user_id
        }
        const response = await postNewOneTimeNoRideForm(data)
        if (response.status !== 201) {
          throw new Error(response.statusText)
        }
        this.hasProps = false
        this.data = {}
        alert('All validation complete, form submitted.')
        this.$router.push('StudentList')
      } catch (error) {
        alert('Form submission failed!')
        console.log(error)
      }
    }
  },
  mounted() {
    this.updateUser()
    if (this.student) {
      this.data.student = [
        {
          first_name: this.student.firstName,
          last_name: this.student.lastName,
          student_id: this.student.studentId
        }
      ]
    } else {
      this.$router.push('StudentList')
    }
  }
}
</script>
